import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import { SearchInput } from "../../widgets";
import { searchWord, isElasticLoad } from "../../../helpers/common";
import { Unit, formatNumber } from "../../../helpers/unit";
import LoadingStyle from "../Common/LoadingStyle";
import { HARVEST_WORK_TYPE_IDS } from "../../../constants";

const seedTruckList = (props) => {
  const {
    selectedWorkTypeIds: activeWorkType,
    egList: { isRequesting: isRequestingEg },
    sourceListById: { isRequestingLoad, isRequestingKpi, payload: sourceDetailsById },
  } = useSelector((state) => state.dashboard.leaderBoard);
  const egReportIssue = useSelector((state) => state.equipmentGroup.EGReportIssue.list);
  const weightShortName = useSelector((state) => state.user.settings.weightShortName);
  const [searchText, setSearchText] = useState("");
  const unit = Unit.getInstance();
  const sourceDetailList = Object.keys(sourceDetailsById).map((id) => sourceDetailsById[id]);


  const getLoadCapacity = (value) => {
    value = value && value.toString().includes(",") ? value.replace(/,/g, "") : value;
    return formatNumber(unit.toFixedOf(unit.toWeight(value, 2), 0));
  };

  const filteredList = useMemo(() => {
    let list = sourceDetailList.filter((e) => e.primaryCategoryId === 4 && activeWorkType.indexOf(e.workTypeId) >= 0 && searchWord(e.equipmentGroupName, searchText)).sort((a, b) => b.equipmentGroupName - a.equipmentGroupName);
    return list;
  }, [sourceDetailsById, searchText]);

  let hasImplementOnly = true;
  activeWorkType.forEach((id) => {
    if (HARVEST_WORK_TYPE_IDS.indexOf(id) >= 0) hasImplementOnly = false;
  });

  const getEGImageURL = (data, egId) => {
    let egIssue = egReportIssue && egReportIssue[egId] ? egReportIssue[egId] : null;
    return egIssue && !egIssue.is_resolve ? data.imgUrl.sm.replace("/sm", "/ic/3") : data.imgUrl.sm;
  };

  return (
    <>
      <Card className={`implement-type ${hasImplementOnly && activeWorkType.length !== 0 ? "" : ""}`}>
        <Col className="h-100 p-0">
          <Row className="search-input">
            <SearchInput className="w-100" onChange={(searchText) => setSearchText(searchText)} />
          </Row>
          <Row className="completion-info">
            <Col className="h-100 p-0">
              <Row className="info-header">
                <div className="name" style={{ width: "33%" }}>
                  Implement
                </div>
                <div style={{ width: "32%" }}>Acres</div>
                <div style={{ width: "30%" }}>Weight ({weightShortName})</div>
              </Row>
              <Row className={`info-body ${(filteredList.length === 0 || isRequestingEg) && "align-items-center"}`}>
                {isRequestingEg ? (
                  <Col className="no-item-found">Loading...</Col>
                ) : filteredList.length === 0 ? (
                  <Col className="no-item-found">No Records Found</Col>
                ) : (
                  <Col className="p-0">
                    {filteredList
                      .sort((a, b) => b.loadCapacity - a.loadCapacity)
                      .map((item) => (
                        <div key={item.equipmentGroupId}>
                          <div className="eg-card d-flex">
                            <div className="eg-info d-flex">
                              <img src={getEGImageURL(item, item.equipmentGroupId)} alt="" className="image" />
                              <div className="name" title={item.equipmentGroupName}>
                                {item.equipmentGroupName}
                              </div>
                            </div>
                            <div style={{ width: `${isElasticLoad() ? "32%" : "32%"}` }} className="value">
                              {isRequestingKpi ? <LoadingStyle /> : item.acres ? unit.toRoundOfArea(item.acres) : 0}
                            </div>
                            {!isElasticLoad() && (
                              <div style={{ width: "30%" }} className="value">
                                {" "}
                                {isRequestingLoad || isRequestingLoad ? <LoadingStyle /> : item.loadCapacity === null ? "-" : getLoadCapacity(item.loadCapacity)}
                              </div>
                            )}
                          </div>
                          <div className="divider"></div>
                        </div>
                      ))}
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Col>
      </Card>
    </>
  );
};

export default seedTruckList;
